import { InitialLoading } from '@anytag/shared-molecules';
import { WithChannelTalk } from '@anytag/app';
import { useUserRoles } from '@anytag/auth';
import { TikTokPermissionRoute } from './permission-route';

export const TiktokRoot = () => {
  const { status } = useUserRoles();

  if (status === 'idle' || status === 'loading') {
    return <InitialLoading />;
  }

  return (
    <WithChannelTalk>
      <TikTokPermissionRoute />
    </WithChannelTalk>
  );
};
